import TripsPlanningContainer from './TripsPlanningContainer';

export default TripsPlanningContainer;
